import { Grid } from "antd";
import { PropsWithChildren } from "react";
import { useLayout } from "../../../context/LayoutContext";
import styles from "./styles.module.scss";
const ContentWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { getContentPadding, getHeaderHeight } = useLayout();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  return (
    <div className={styles.container}>
      <div
        className={styles.contentWrapper}
        style={{ padding: getContentPadding() }}
      >
        <div
          className={styles.contentContainer}
          style={{ paddingTop: getHeaderHeight() }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContentWrapper;
